export default __webpack_public_path__ + "static/media/monsters.2c5dd756.png";